module.exports = __webpack_public_path__ + "img/example2.083f66ca.jpg";